// 用户反馈列表组件
export default {
  // 页面标题
  title: "用户反馈列表",

  // 搜索和筛选
  usernamePlaceholder: "请输入用户名称",
  selectTypePlaceholder: "请选择类型",
  reset: "重置",
  search: "查询",

  // 统计和加载
  totalRecords: "共计",
  records: "条数据",
  loading: "拼命加载中",

  // 表格列名
  username: "用户名称",
  phoneNumber: "手机号",
  email: "邮箱",
  type: "类型",
  content: "内容",
  createTime: "创建时间",
  remark: "备注",
  view: "查看",

  // 操作
  detail: "详情",

  // 反馈类型
  all: "全部",
  problemFeedback: "问题反馈",
  featureSuggestion: "功能建议",
  caseAssistance: "案情协助",

  // 备注
  addRemark: "点击添加备注",
  remarkSuccess: "修改备注成功",

  // 详情字段
  userId: "用户ID：",
  contactInfo: "联系方式：",
  emailLabel: "邮箱：",
  createTimeLabel: "创建时间：",
  contentLabel: "内容：",
};
